import type {Optional} from '@logistics-frontend/types'
import type {SuggestLocation} from '@yandex-delivery/api/model/suggest'
import {get} from '@yandex-delivery/utils'

type PointWithCoordinates = {
  latitude?: number
  longitude?: number
}

export const getPointCoordinates = <T extends PointWithCoordinates>(point: T): Optional<SuggestLocation> => {
  // Кривая типизация GetIn (внутри функции get)
  // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
  const latitude = get('latitude', point)
  // Кривая типизация GetIn (внутри функции get)
  // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
  const longitude = get('longitude', point)

  if (latitude && longitude) {
    return [longitude, latitude]
  }

  return undefined
}
